import { render, staticRenderFns } from "./permDocument.vue?vue&type=template&id=07e60f4c&scoped=true"
import script from "./permDocument.vue?vue&type=script&lang=js"
export * from "./permDocument.vue?vue&type=script&lang=js"
import style0 from "./permDocument.vue?vue&type=style&index=0&id=07e60f4c&prod&lang=scss"
import style1 from "./permDocument.vue?vue&type=style&index=1&id=07e60f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e60f4c",
  null
  
)

export default component.exports